module.exports = __webpack_public_path__ + "static/media/icon-four-square.59c3549b.svg";